<template>
  <MapContainer/>
</template>

<script>

import MapContainer from "@/components/MapContainer.vue";

export default {
  name: 'App',
  components: {
    MapContainer,
  }
}
</script>

<style scoped>
</style>
